import { setScalePosition } from './math3d';

export const setGltfScalePosition = (gltf, dontScale, initMat) => {
  if (gltf && !dontScale) {
    const boundsBox = setScalePosition(gltf.scene, [0, 0.5, 0], initMat);
    return boundsBox;
  }
};
